import { Component, h, Prop } from '@stencil/core';
import { ProgressStepperSize, ProgressStepperVariant, Step } from './jui-progress-stepper.model';

@Component({
  tag: 'jui-progress-stepper',
  styleUrl: 'jui-progress-stepper.scss',
  shadow: true
})
export class JuiProgressStepper {
  /**
   * Progress color: primary | secondary | success | info | warning | danger | low | high | subtle
   */
  @Prop() color: ProgressStepperVariant = ProgressStepperVariant.primary;

  /**
   * Progress size: xs | sm | md | lg | xl
   */
  @Prop() size: ProgressStepperSize = ProgressStepperSize.md;

  /**
   * Progress total number of steps
   */
  @Prop() total = 0;

  /**
   * Progress current step
   */
  @Prop() step = 0;

  render() {
    const steps: Step[] = [];
    for (let i = 1; i <= this.total; i++) {
      steps.push({
        index: i,
        classMap: {
          ['progress-stepper__step']: true,
          ['progress-stepper__step--active']: i <= this.step,
          [this.color]: true,
          [this.size]: true
        }
      });
    }

    const classMap = {
      ['progress-stepper']: true,
      [this.size]: true
    };

    return (
      <div class={classMap}>
        <div class={'progress-stepper__label'}>
          <slot></slot>
        </div>
        <div class={'progress-stepper__steps'}>
          {steps.map((step: Step) => (
            <div class={step.classMap}></div>
          ))}
        </div>
      </div>
    );
  }
}
